import { Box, Typography } from "@mui/material";
import { DownloadFile } from "utils/download.util";

const RulesPolicyDoc = () => {
  return (
    <Box
      sx={{
        px: { md: "2%", lg: "2%", xl: "2%", sm: "4%", xs: "4%" },
        py: "0px",
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "18px",
          lineHeight: "31px",
          mt: "20px",
          mb: "10px",
        }}
      >
        Rules and Policies
      </Typography>

      <Box
        sx={{
          my: "15px",
          border: "1px solid #E2E2E2",
          borderRadius: "10px",
          padding: "20px",

          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", gap: "20px", alignItems: "center" }}>
          <img
            src="/assets/img/icons/pdf_ic.svg"
            alt=""
            width="36"
            height="48"
          />

          <Box>
            <Typography
              sx={{
                color: "#383838",
                fontSize: "15px",
                fontWeight: 500,
                lineHeight: "22px",
              }}
            >
              Haystackers Rules and Policies.pdf
            </Typography>
            <Typography
              sx={{
                color: "#A2A2A2",
                fontSize: "13px",
                fontWeight: 400,
                lineHeight: "22px",
              }}
            >
              3 pages • 1.2 MB • PDF
            </Typography>
          </Box>
        </Box>
        <img
          src="/assets/img/icons/arrow_down_cr.svg"
          alt=""
          width="36"
          height="48"
          onClick={() =>
            DownloadFile(
              "https://us-central1-haystackers-84f94.cloudfunctions.net/api/v1/public/Haystackers%20Privacy%20Policy%20and%20CA%20Privacy%20Policy.pdf",
              "Rules and Policy"
            )
          }
        />
      </Box>
    </Box>
  );
};

export default RulesPolicyDoc;
